module.exports = __webpack_public_path__ + "static/media/training_mind_body_fitness_arms_outstretched.209d08fe.webp";